export default __webpack_public_path__ + "static/media/ic_top_bg.0e886b7c.svg";